module.exports = __webpack_public_path__ + "static/img/default-shop-banner.4ffa6a50.png";